export type PromocodeTypes = 'cash' | 'private' | 'public';

export class PromocodeModel {
  id?: number;
  code: string;
  usedDatetime?: Date;
  createdDatetime?: Date;
  expirationDatetime?: Date | string;
  type: PromocodeTypes;
  discountPercentage?: number;
  userEmail: string;
  thesisOrderId: number;
  thesisOrder?: any;
}

